import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDefaultFile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1231 23H7.37685C5.51143 23 4 21.5018 4 19.6527V4.34732C4 2.49822 5.51143 1 7.37685 1H15.8423L20.5 5.63778V19.6527C20.5 21.5018 18.9886 23 17.1231 23Z",
			fill: "#8C8C8C"
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20.5 5.63778H16.7994C16.2755 5.63778 15.8493 5.21763 15.8493 4.69822L15.8423 1",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.2366 14.855C14.7898 14.3018 14.7898 13.4048 14.2366 12.8516L12.0563 10.6713C11.9262 10.5412 11.9262 10.3301 12.0563 10.1999C12.1865 10.0698 12.3976 10.0698 12.5277 10.1999L14.708 12.3802C15.5216 13.1938 15.5216 14.5128 14.708 15.3264C13.8944 16.14 12.5753 16.14 11.7617 15.3264L9.11038 12.6751C8.5244 12.0892 8.5244 11.1391 9.11038 10.5531C9.69636 9.96716 10.6464 9.96716 11.2324 10.5531L13.8834 13.2041C14.2415 13.5623 14.2415 14.143 13.8834 14.5011C13.5252 14.8593 12.9445 14.8593 12.5863 14.5011L10.1707 12.0855C10.0405 11.9554 10.0405 11.7443 10.1707 11.6141C10.3009 11.484 10.5119 11.484 10.6421 11.6141L13.0577 14.0297C13.1555 14.1276 13.3141 14.1276 13.412 14.0297C13.5098 13.9319 13.5098 13.7733 13.412 13.6755L10.761 11.0245C10.4354 10.6989 9.90741 10.6989 9.58178 11.0245C9.25616 11.3502 9.25616 11.8781 9.58178 12.2037L12.2331 14.855C12.7863 15.4083 13.6833 15.4083 14.2366 14.855Z",
			fill: "white"
		})
	]
});
export default SvgDefaultFile;
